export const getBreakpoints = () => {
    const SCREEN_WIDTH = window.innerWidth;
    if (SCREEN_WIDTH <= 480) {
        return "sp";
    } else {
        return "pc"
    }
}